/* SB — Galerie-Pfeile: vor/zurück durch die Produktbilder.
   Nutzt Dawns vorhandene Thumbnail-Logik (Klick auf Thumbnail = Bildwechsel),
   mit Fallback auf setActiveMedia für Layouts ohne Thumbnails. */
(function () {
  function cycle(list, currentIndex, dir) {
    return (currentIndex + dir + list.length) % list.length;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sb-gallery-prev],[data-sb-gallery-next]');
    if (!btn) return;
    e.preventDefault();

    var gallery = btn.closest('media-gallery');
    if (!gallery) return;
    var dir = btn.hasAttribute('data-sb-gallery-next') ? 1 : -1;

    // 1) Bevorzugt: über die Thumbnails (Dawns Standard-Mechanik)
    var thumbs = Array.prototype.slice.call(
      gallery.querySelectorAll('.thumbnail-list__item button')
    );
    if (thumbs.length > 1) {
      var ti = thumbs.findIndex(function (t) {
        return t.getAttribute('aria-current') === 'true';
      });
      if (ti < 0) ti = 0;
      thumbs[cycle(thumbs, ti, dir)].click();
      return;
    }

    // 2) Fallback: direkt über die Slides + setActiveMedia
    var slides = Array.prototype.slice.call(
      gallery.querySelectorAll('.product__media-list > .product__media-item')
    );
    if (slides.length < 2 || typeof gallery.setActiveMedia !== 'function') return;
    var si = slides.findIndex(function (s) {
      return s.classList.contains('is-active');
    });
    if (si < 0) si = 0;
    var nextSlide = slides[cycle(slides, si, dir)];
    if (nextSlide && nextSlide.dataset.mediaId) {
      gallery.setActiveMedia(nextSlide.dataset.mediaId, true);
    }
  });
})();
